import { AttachmentModel } from './attachment.model';
import { BaseModel } from './base.model';

export class ListValueModel extends BaseModel {

    integration_id: number;
    description: string;
    list_id: number;
    status: boolean;

    logo_attachment_id: number;
    logo: AttachmentModel;

    static validate(value: ListValueModel): boolean {
        return !!(value.description);
    }

    constructor(value?: ListValueModel) {
        super();

        this.integration_id = value ? value.integration_id || null : null;
        this.description = value ? value.description || null : null;
        this.list_id = value ? value.list_id || null : null;
        this.status = value ? value.status || null : null;

        this.logo_attachment_id = value ? value.logo_attachment_id || null : null;
        this.logo = value ? value.logo || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/list-value.model.ts